import { render } from "./UpgradeComponent.vue?vue&type=template&id=3e253507&scoped=true"
import script from "./UpgradeComponent.vue?vue&type=script&lang=js"
export * from "./UpgradeComponent.vue?vue&type=script&lang=js"

import "./UpgradeComponent.vue?vue&type=style&index=0&id=3e253507&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e253507"]])

export default __exports__